import { useMemo } from "react";

import renderAvailableBalance from "../../Organisms/Modals/Banking/available-balance";
import renderCurrentBalance from "../../Organisms/Modals/Banking/current-balance";

import { useModalContext } from "../../Contexts/ModalContext";

import { useActivities, useStakeDebit } from "../../CustomHooks/Queries";

import { maskAccountNumber } from "../../Utils/pii";
import { formatCurrency, formatNumberWithCentsToUSD, isSVDApproved } from "../../Utils/helpers";

import { Wallet } from "../../Assets/Icons";

export default function StakeAccount() {
  const modalContext = useModalContext();

  const { data: stakeDebit } = useStakeDebit();
  const { data: activitiesData } = useActivities();

  const IsSVDApproved = useMemo(() => isSVDApproved(stakeDebit?.data), [stakeDebit?.data]);

  const availableBalance = useMemo(() => stakeDebit?.data?.data?.available ?? 0, [stakeDebit]);
  const currentBalance = useMemo(() => activitiesData?.data?.data?.currentBalance ?? 0, [activitiesData]);

  const displayAvailableBalance = IsSVDApproved
    ? formatNumberWithCentsToUSD(availableBalance)
    : formatCurrency(currentBalance);

  return (
    <div className="stake-account">
      <div className="stake-account-header">
        <div className="stake-account-icon-row">
          <div className="wallet-icon-container">
            <Wallet />
          </div>
          <div className="account-title-container">
            <span className="account-title">Stake {IsSVDApproved ? "Checking" : "Wallet"}</span>
            {IsSVDApproved && (
              <span className="account-subtitle">
                Checking{" "}
                {maskAccountNumber(stakeDebit?.data?.data?.account_number, {
                  wrap: false,
                  prefix: "••",
                })}
              </span>
            )}
          </div>
        </div>
        <div className="stake-account-balance">
          <button className="balance-label" type="button" onClick={() => renderAvailableBalance(modalContext)}>
            Available balance
          </button>
          <p className="balance-amount">{displayAvailableBalance}</p>
        </div>
      </div>
      <div className="stake-account-details">
        <div className="detail-row">
          <button className="detail-label" onClick={() => renderCurrentBalance(modalContext)}>
            Current balance
          </button>
          <span className="detail-value">{formatCurrency(currentBalance)}</span>
        </div>
      </div>
    </div>
  );
}
